import React from "react";
import PropTypes from "prop-types";
import {reaction} from "mobx";
import useAuth from "../hooks/use-auth";
import {useOperation} from "@morningtrain/react-resources";

function RefreshOnLoginReaction(props) {

    const auth = useAuth();
    const operation = useOperation();

    const handleReaction = () => {

        const {auth, onLogin, onLogout} = this.props;
        const loggedIn = auth.check();

        const shouldReact = (onLogin && loggedIn) || (onLogout && !loggedIn);

        if (operation && shouldReact) {
            operation.refresh();
        }
    };

    reaction(
        () => auth.user.get('id'),
        handleReaction,
        {fireImmediately: props.fireImmediately}
    );

    return null;
}

RefreshOnLoginReaction.defaultProps = {
    fireImmediately: false,
    onLogin: true,
    onLogout: true,
}

RefreshOnLoginReaction.propTypes = {
    fireImmediately: PropTypes.bool,
    onLogin: PropTypes.bool,
    onLogout: PropTypes.bool,
};

export default RefreshOnLoginReaction;
